import React from "react";
import { TextField, Chip, Autocomplete } from "@mui/material";
import { Controller } from "react-hook-form-v7";

const MultiSelectChip = ({ control, filter, data = [], name = "value", defaultValue = [], multiSelect = true, label, disabled, onChange }) => {
  return (
    <>
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={({ field }) => (
          <Autocomplete
            multiple={multiSelect}
            style={{ marginBottom: 8, marginTop: 4 }}
            options={data.filter((option) => {
              const selected = Array.isArray(field?.value)
                ? field.value
                : field?.value
                ? [field.value]
                : [];
              return !selected.some((item) => item.value === option.value);
            })}
            value={field?.value || []}
            disabled={disabled}
            onChange={(_, value) =>  {
              field.onChange(value);
              onChange && onChange(value);
            }}
            isOptionEqualToValue={(option, value) => {
              return option.value === value.value;
            }}
            getOptionLabel={(option) => option?.title || ""}
            getOptionKey={(option) => option.value}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  {...getTagProps({ index })}
                  key={option.value}
                  label={option.title}
                  size="small"
                  variant="outlined"
                  style={{ margin: 5 }}
                />
              ))
            }
            renderInput={(params) => (
              <TextField
                {...params}
                disabled={disabled}
                sx={{
                  "& .MuiInputBase-root": {
                    paddingLeft: 0,
                    paddingRight: 0,
                  },
                  "& input": {
                    paddingLeft: 0,
                    paddingRight: 0,
                    fontSize: 14,
                  },
                  "& .MuiInputLabel-root": {
                    fontSize: 14,
                  },
                  "& .MuiInputLabel-shrink": {
                    transform: "translate(20px, -6px) scale(0.75)",
                  },
                }}
                label={label}
              />
            )}
          />
        )}
      />
    </>
  );
};

export default MultiSelectChip;
